import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { createClasses } from '@kp/react-ui';
import { FormProvider, useForm } from 'react-hook-form';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { ActionsBar } from '../../../components/ActionsBar';
import { AddressForm } from '../../../components/Address';

const classes = createClasses({
  actionButton: {
    marginLeft: '8px',
  },
});

export interface SiteLocationData {
  location: {
    city: string;
    country: string;
    no: string;
    street: string;
    zip: string;
  };
}

type SiteLocationProps = SiteLocationData & {
  loading: boolean;
  onSubmit: (location: SiteLocationData) => void;
  onDiscard: () => void;
};

export const SiteLocation: React.FC<SiteLocationProps> = ({
  loading,
  location,
  onSubmit,
  onDiscard,
}) => {
  const { t } = useTranslation(['sites', 'general']);

  const defaultValues: SiteLocationData = {
    location,
  };
  const methods = useForm({
    defaultValues,
  });
  const { handleSubmit, reset } = methods;
  useDeepCompareEffect(() => {
    reset({
      location,
    });
  }, [reset, location]);

  return (
    <FormProvider {...methods}>
      <ActionsBar>
        <Button
          onClick={onDiscard}
          color="secondary"
          size="large"
          className={classes.actionButton}
          aria-label="discard-button"
        >
          {t('general:buttons.discard')}
        </Button>
        <Button
          onClick={handleSubmit(onSubmit)}
          className={classes.actionButton}
          color="secondary"
          variant="outlined"
          size="large"
          aria-label="save-button"
          disabled={loading}
        >
          {t('general:buttons.save')}
        </Button>
      </ActionsBar>
      <AddressForm loading={loading} />
    </FormProvider>
  );
};
